<template lang="pug">
transition(name="fade")
  .CountdownOverlay(v-if="!isFinished")
    .inner(:style="innerStyle")
      .title
        span(v-if="count === 3") {{ messages[0] }}
        span(v-if="count === 2") {{ messages[1] }}
        span(v-if="count === 1") {{ messages[2] }}
</template>

<script>
// import moment from 'moment'

export default {
  name: 'km-countdown-overlay',
  components: {},
  props: {
    time: {
      type: Number,
      default: 3
    },
    messages: {
      type: Array,
      default: () => ['いざ', '尋常に', '始め']
    },
    color: {
      type: String,
      default: 'rgba(0,0,0,0.8)'
    },
    font: {
      type: String,
      default: 'serif'
    }
  },
  data() {
    return {
      isFinished: false,
      count: 3,
      decrementTimerInstance: null
    }
  },
  computed: {
    innerStyle() {
      return {
        background: this.color,
        fontFamily: this.font
      }
    }
  },
  methods: {
    end() {
      this.isFinished = true
      clearInterval(this.decrementTimerInstance)
      this.$emit('onFinished')
    },
    decrementCount() {
      if (this.count === 1) {
        this.end()
        return
      }
      this.count -= 1
    }
  },
  mounted() {
    this.decrementTimerInstance = setInterval(this.decrementCount, 1200)
  },
  beforeDestroy() {
    clearInterval(this.decrementTimerInstance)
  }
}
</script>

<style lang="scss" scoped>
.CountdownOverlay {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  align-items: center;
  justify-content: center;
  z-index: 1000;

  .inner {
    display: flex;
    width: 100%;
    padding: 50px;
    background: rgba(#000, 1);
    color: #fff;
    font-size: 8rem;
    align-items: center;
    justify-content: center;
  }
}
</style>
